export default __webpack_public_path__ + "static/media/2c.1ee949e2.png";